import React from 'react'
import { BrowserRouter, Route, Routes as Router } from 'react-router-dom'
import Container from '../components/wrappers/Container'
import { Error404, Home, Login, RecoveryCode, ResetPassword, Profile, EditProfile, RequestAccess, ReceivedRequest, Maintenances } from '../pages'
import ForgotPassaword from '../pages/auth/ForgotPassword'
import EditPassword from '../pages/profile/EditPassword'
import CustomRoute from './CustomRoute'

export default function Routes(): React.ReactElement {
    return (
        <BrowserRouter>
            <Router>
                <Route
                    path="/login"
                    element={
                        <CustomRoute public>
                            <Login />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/request-access"
                    element={
                        <CustomRoute public>
                            <RequestAccess />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/received-request"
                    element={
                        <CustomRoute public>
                            <ReceivedRequest />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/forgot-pass"
                    element={
                        <CustomRoute public>
                            <ForgotPassaword />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/recovery-code"
                    element={
                        <CustomRoute public>
                            <RecoveryCode />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/reset-password"
                    element={
                        <CustomRoute public>
                            <ResetPassword />
                        </CustomRoute>
                    }
                />
                <Route
                    path="/"
                    element={
                        <CustomRoute private>
                            <Container>
                                <Home />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/profile"
                    element={
                        <CustomRoute private>
                            <Container>
                                <Profile />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/edit-profile"
                    element={
                        <CustomRoute private>
                            <Container>
                                <EditProfile />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/edit-password"
                    element={
                        <CustomRoute private>
                            <Container>
                                <EditPassword />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route
                    path="/maintenances"
                    element={
                        <CustomRoute private>
                            <Container>
                                <Maintenances />
                            </Container>
                        </CustomRoute>
                    }
                />
                <Route path="*" element={<Error404 />} />
            </Router>
        </BrowserRouter>
    )
}
